import api, { openApi } from "../../services/api";
import { getCurrentDomain } from "../../utils/tenant";

const useSettings = () => {
  const getAll = async (params) => {
    const { data } = await api.request({
      url: "/settings",
      method: "GET",
      params,
    });
    return data;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  };

  const get = async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  };

  const getPublicSetting = async (key, companyId = null) => {
    const params = { domain: getCurrentDomain() };
    if (companyId) params.companyId = companyId;
    const { data } = await openApi.request({
      url: `/public-settings/${key}`,
      method: "GET",
      params,
    });
    return data;
  };

  /**
   * Marca pública do domínio acessado (Revenda).
   * → { appName, appLogoLight, appLogoDark, appLogoFavicon, appLogoBackgroundLight,
   *     appLogoBackgroundDark, primaryColorLight, primaryColorDark, enabledLanguages,
   *     userCreation, companyId, resellerId, slug, customDomain }
   * Chaves ausentes vêm como undefined — quem chama aplica os fallbacks.
   */
  const getPublicBrand = async () => {
    const { data } = await openApi.request({
      url: "/public-brand",
      method: "GET",
      params: { domain: getCurrentDomain() },
    });
    return data && typeof data === "object" ? data : {};
  };

  return {
    getAll,
    update,
    get,
    getPublicSetting,
    getPublicBrand,
  };
};

export default useSettings;
